export default __webpack_public_path__ + "static/media/scanning.10bfd2d2.gif";